import { FC } from 'react'

import { AnimatedSpinner } from '../AnimatedSpinner'

export const Loader: FC<{ label: string }> = ({ label }) => (
  <div className="flex justify-center items-center h-full opacity-50 fixed top-0 left-0 w-full bg-black z-[1]">
    <div className="flex-col h-[75vh] text-white gap-2 overflow-auto content-center justify-center text-center">
      <div className="flex items-center gap-2 flex-col">
        <AnimatedSpinner />
        <div className="text-3xl mb-2">{label}</div>
      </div>
    </div>
  </div>
)
